import { useServices } from 'app/hooks.ts';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectDarkVenueMappingsState } from 'widgets/darkVenueHeatmap/venueMappings/selectors.ts';
import State from 'store/State';

export const useSelectDarkVenueMappings = () =>
    useSelector((state: State) => selectDarkVenueMappingsState(state).mappings);

export default function useDarkVenueMappings() {
    const { darkVenueMappingsService } = useServices();
    const mappings = useSelectDarkVenueMappings();

    useEffect(() => {
        darkVenueMappingsService.fetchMappings();
    }, [darkVenueMappingsService]);

    return mappings;
}
